import { render, staticRenderFns } from "./EditAvisLoyer.vue?vue&type=template&id=1ab63566&"
import script from "./EditAvisLoyer.vue?vue&type=script&lang=ts&"
export * from "./EditAvisLoyer.vue?vue&type=script&lang=ts&"
import style0 from "./EditAvisLoyer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports